import script from "./CasinoPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasinoPage.vue?vue&type=script&setup=true&lang=ts"

import "./CasinoPage.vue?vue&type=style&index=0&id=7dac7d1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dac7d1c"]])

export default __exports__